import React, { FC } from 'react';
import './FilterAlertedFlightsToggle.scss';
import { ReactComponent as AlertIcon } from 'images/alert.svg';

interface FilterAlertedFlightsToggleProps {
    filterAlertedFlights: boolean;
    onToggleFilterAlertedFlights: () => void;
}

const FilterAlertedFlightsToggle: FC<FilterAlertedFlightsToggleProps> = (props) => {
    const handleClick = () => {
        props.onToggleFilterAlertedFlights();
    };

    return (
        <button
            className={`filter-alerted-flights-toggle${
                props.filterAlertedFlights ? ' filter-alerted-flights-toggle--enabled' : ''
            }`}
            data-testid="filter-alerted-flights-toggle"
            type="button"
            onClick={handleClick}
        >
            <AlertIcon />
            Alerted Flights
        </button>
    );
};

export default FilterAlertedFlightsToggle;
